export default __webpack_public_path__ + "static/media/coming-soon.968759e8.svg";